import React from 'react';
import {Link} from "react-router-dom";

function Home(){
  document.documentElement.setAttribute("planet-size", "large");
  return(
    <div class="about-me">
      <h1>FEATURED ✦</h1>
      <p>✦ <a href="https://contralto.herokuapp.com/" target="_blank"><strong>Contralto: </strong></a> A Flask app analyzing the gender diversity of your Spotify playlists.</p>
      <p>✦ <a href="https://cdinhart.itch.io/ctrrrl-zine" target="_blank"><strong>CTRRRL-ZINE:</strong></a> A printable, pocket-sized punk guide to creative coding.</p>
      <p>✦ <a href="https://cdinhart.itch.io/popculturewiki" target="_blank"><strong>The All-Devouring Pop Culture Wiki:</strong></a> 15 poems about TVTropes, identity, superheroes, girls in movies, nostalgic rock anthems, and growing up on screens.</p>
      <br></br>
      <Link className="cool stack-link" to="/about"><strong>About + Contact</strong></Link><br></br>
      <Link className="cool stack-link" to="/commissions"><strong>Commissions</strong></Link><br></br>
      <Link className="warm stack-link" to="/design-notes"><strong>Design Notes</strong></Link>
    </div>
  );
}

export default Home;